import { Component, OnDestroy, OnInit } from '@angular/core';
import { NewsService } from '../../Services/news.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  Blogdata: any[] = [];
  paginatedData: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 5;
  isLoading: boolean = false;

  constructor(private newsService: NewsService, private router: Router) { }

  ngOnInit() {
    // Scroll to top on navigation end
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });

    // Fetch blog data on initialization
    this.getBlogData();
  }

  getBlogData() {
    this.isLoading = true;
    this.subscription = this.newsService.GetBlog().subscribe(
      res => {
        this.isLoading = false;
        if (res && res.Response && res.Response.Data && res.Response.Data.NewsBlogList) {
          this.Blogdata = res.Response.Data.NewsBlogList;
          this.updatePaginatedData();
        }
      },
      err => {
        console.error('Error in blog component', err);
        this.isLoading = false;
      }
    );
  }

  updatePaginatedData() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedData = this.Blogdata.slice(start, end);
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.updatePaginatedData();
  }

  nextPage() {
    if (this.currentPage < this.totalPages()) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }

  totalPages() {
    return Math.ceil(this.Blogdata.length / this.itemsPerPage);
  }

  onNavigate(type, data) {
    if (type == "NewsDetail") {
      setTimeout(() => {
        this.router.navigate(['/news-details', data]);
      }, 500);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
